import React from "react";

export const GradientBackground = () => (
  <div className="absolute w-full h-full overflow-hidden bg-ssblue">
    <div
      className="absolute inset-0"
      style={{
        background:
          "linear-gradient(125deg, #3E8DFF 0%, #FF7AAC 25%, #F0BE39 50%, #3EB567 75%, #3E8DFF 100%)",
        backgroundSize: "400% 400%",
        animation: "gradientShift 18s ease infinite",
        opacity: 0.9,
      }}
    />
    <style>{`
      @keyframes gradientShift {
        0%,100% { background-position: 0% 50%; }
        50%     { background-position: 100% 50%; }
      }
    `}</style>
  </div>
);
